import { render, staticRenderFns } from "./DriverAppCheckListDialog.vue?vue&type=template&id=96c3e6ae&scoped=true"
import script from "./DriverAppCheckListDialog.vue?vue&type=script&lang=js"
export * from "./DriverAppCheckListDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverAppCheckListDialog.vue?vue&type=style&index=0&id=96c3e6ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c3e6ae",
  null
  
)

export default component.exports